export {isBoolean} from './is-boolean.fn';
export {isString} from './is-string.fn';
